import React, {FC} from 'react';

import {PortalSuccessBannerState} from '../../../../store/panels/app/banners/bannersState';
import {PortalSuccessBanner} from './portalSuccessBanner';

/*
 * Props.
 */

interface PortalBannersProps {
  successBanners: ReadonlyArray<PortalSuccessBannerState>;
}

/*
 * Component.
 */

export const PortalBanners: FC<PortalBannersProps> = ({successBanners}) => (
  <>
    {successBanners.map((banner) => (
      <PortalSuccessBanner key={banner.uid} state={banner} />
    ))}
  </>
);
